import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Routes, provideRouter } from '@angular/router';
import { donationRoute } from '@donation/donation.config';
import { loginRoute } from '@features/login/login.config';
import { provideIcons } from '@ng-icons/core';
import { PROJECT_ICONS } from '@shared/components/icon/icon.config';
import { auth } from '@shared/interceptors/auth/auth.interceptor';
import { baseUrl } from '@shared/interceptors/base-url/base-url.interceptor';
import { refreshToken } from '@shared/interceptors/refresh-token/refresh-token.interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export const routes: Routes = [
  ...loginRoute,
  ...donationRoute,
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found.component').then(m => m.NotFoundComponent),
    data: {
      title: 'Página não encontrada',
      search: false,
      fullscreen: true
    }
  }
];

export const appConfig: ApplicationConfig = {
  providers: [provideAnimationsAsync(), provideRouter(routes), provideHttpClient(withInterceptors([baseUrl, refreshToken, auth])), provideEnvironmentNgxMask(), provideIcons(PROJECT_ICONS)]
};
